import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminComponent } from './admin.component';
import { ClientsComponent } from './clients/clients.component';
import { TemplatesComponent } from './templates/templates.component';
import { HelpComponent } from './help/help.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ClientEditComponent } from './clients/client-edit/client-edit.component';
import { ClientDashboardComponent } from './clients/client-dashboard/client-dashboard.component';
import { ElementsComponent } from './templates/elements/elements.component';
import { QuickDesignsComponent } from './templates/quick-designs/quick-designs.component';
import { QuickDesignEditComponent } from './templates/quick-designs/quick-design-edit/quick-design-edit.component';
import { ElementEditComponent } from './templates/elements/element-edit/element-edit.component';
import { GroupsComponent } from './groups/groups.component';
import { GroupEditComponent } from './groups/group-edit/group-edit.component';
import { GroupDashboardComponent } from './groups/group-dashboard/group-dashboard.component';
import { QuickDesignBuildComponent } from './templates/quick-designs/quick-design-build/quick-design-build.component';
import { SettingAdminComponent } from './setting-admin/setting-admin.component';
import { MastersComponent } from './templates/masters/masters.component';
import { MasterEditComponent } from './templates/masters/master-edit/master-edit.component';
import { ElementHtmlComponent } from './templates/elements/element-html/element-html.component';
import { StylesComponent } from './styles/styles.component';
import { StyleDashboardComponent } from './styles/style-dashboard/style-dashboard.component';
import { StyleEditComponent } from './styles/style-edit/style-edit.component';
import { ClientGalleryComponent } from './clients/client-gallery/client-gallery.component';
import { TrainingVideosComponent } from './help/training-videos/training-videos.component';
import { SupportComponent } from './help/support/support.component';
import { FaqsComponent } from './help/faqs/faqs.component';
import { TrainingVideosEditComponent } from './help/training-videos/training-videos-edit/training-videos-edit.component';
import { TrainingVideosDashboardComponent } from './help/training-videos/training-videos-dashboard/training-videos-dashboard.component';
import { FaqDashboardComponent } from './help/faq-dashboard/faq-dashboard.component';
import { FaqEditComponent } from './help/faq-edit/faq-edit.component';
import { AuthGuard } from '../services/auth-guard.service';
import { IconsComponent } from './icons/icons.component';
import { IconsDashboardComponent } from './icons/icons-dashboard/icons-dashboard.component';
import { IconsEditComponent } from './icons/icons-edit/icons-edit.component';
import { FaqCategoryEditComponent } from './help/faq-category-edit/faq-category-edit.component';
import { FaqCategoryDashboardComponent } from './help/faq-category-dashboard/faq-category-dashboard.component';
import { AuthAdminGuard } from '../services/auth-admin-guard.service';
import { AnalyticUserLogsComponent } from './analytics/analytic-user-logs/analytic-user-logs.component';
import { AnalyticTemplateUsageComponent } from './analytics/analytic-template-usage/analytic-template-usage.component';

import { ChangelogDashboardComponent } from './help/changelog-dashboard/changelog-dashboard.component';
import { ChangelogEditComponent } from './help/changelog-edit/changelog-edit.component';
import { SubgroupsComponent } from './subgroups/subgroups.component';
import { SubgroupsDashboardComponent } from './subgroups/subgroups-dashboard/subgroups-dashboard.component';
import { SubgroupsEditComponent } from './subgroups/subgroups-edit/subgroups-edit.component';
import { WebsitesComponent } from './websites/websites.component';
import { WebsiteDashboardComponent } from './websites/website-dashboard/website-dashboard.component';
import { WebsiteEditComponent } from './websites/website-edit/website-edit.component';
import { WebsiteLogsComponent } from './websites/website-logs/website-logs.component';
import { AdminBlacklistsComponent } from './admin-blacklists/admin-blacklists.component';
import { BlacklistsDashboardComponent } from './admin-blacklists/blacklists-dashboard/blacklists-dashboard.component';
import { BlacklistsEditComponent } from './admin-blacklists/blacklists-edit/blacklists-edit.component';

const adminRoutes: Routes = [
  { path: 'admin', component: AdminComponent, canActivate: [AuthAdminGuard], children: [
    { path: '', redirectTo: 'clients', pathMatch: 'full'},
    { path: 'blacklists', component: AdminBlacklistsComponent, children: [
      { path: '', component: BlacklistsDashboardComponent},
      { path: 'new', component: BlacklistsEditComponent},
      { path: ':id/edit', component: BlacklistsEditComponent},
    ] },
    { path: 'clients', component: ClientsComponent, children: [
      { path: '', component: ClientDashboardComponent},
      { path: 'new', component: ClientEditComponent},
      { path: 'new/:section', component: ClientEditComponent},
      { path: ':id/edit', component: ClientEditComponent},
      { path: ':id/edit/:section', component: ClientEditComponent},
      { path: ':id/gallery', component: ClientGalleryComponent},
      { path: ':id/gallery/:type', component: ClientGalleryComponent},
      { path: ':id/gallery/:type/:gid', component: ClientGalleryComponent}
    ] },
    { path: 'templates', component: TemplatesComponent, children: [
      { path: '', component: ElementsComponent},
      { path: 'elements', component: ElementsComponent},
      { path: 'elements/:type', component: ElementsComponent},
      { path: 'elements/:type/new', component: ElementEditComponent},
      { path: 'elements/:type/new/:block', component: ElementEditComponent},
      { path: 'elements/:type/:id/edit/:dupe', component: ElementEditComponent},
      { path: 'elements/:type/:id/edit', component: ElementEditComponent},
      { path: 'elements/:type/:id/html', component: ElementHtmlComponent},
      { path: 'quick-designs', component: QuickDesignsComponent},
      { path: 'quick-designs/:type', component: QuickDesignsComponent},
      { path: 'quick-designs/:type/new', component: QuickDesignEditComponent},
      { path: 'quick-designs/:type/:id/edit', component: QuickDesignEditComponent},
      { path: 'quick-designs/:type/:id/build', component: QuickDesignBuildComponent},
      { path: 'masters', component: MastersComponent},
      { path: 'masters/:type', component: MastersComponent},
      { path: 'masters/:type/new', component: MasterEditComponent},
      { path: 'masters/:type/:id/edit/:dupe', component: MasterEditComponent},
      { path: 'masters/:type/:id/edit', component: MasterEditComponent}
    ] },
    { path: 'groups', component: GroupsComponent, children: [
      { path: '', component: GroupDashboardComponent},
      { path: 'new', component: GroupEditComponent},
      { path: ':id/edit', component: GroupEditComponent},
    ] },
    { path: 'subgroups', component: SubgroupsComponent, children: [
      { path: '', component: SubgroupsDashboardComponent },
      { path: 'new', component: SubgroupsEditComponent },
      { path: ':id/edit', component: SubgroupsEditComponent }
    ]},
    { path: 'icons', children: [
      { path: '', component: IconsDashboardComponent },
      { path: 'new', component: IconsEditComponent },
      { path: ':id/edit', component: IconsEditComponent }
    ]},
    { path: 'help', component: HelpComponent, children: [
      {path: 'training-videos', children: [
        { path: '', component: TrainingVideosDashboardComponent },
        { path: 'new', component: TrainingVideosEditComponent},
        { path: ':id/edit', component: TrainingVideosEditComponent}
      ] },
      {path: 'faqs', children: [
        {path: '', component: FaqDashboardComponent },
        {path: 'new', component: FaqEditComponent },
        {path: ':id/edit', component: FaqEditComponent },
      ] },
      {path: 'support', component: SupportComponent },
      {path: 'faqscategory', component: HelpComponent, children: [
        {path: '', component: FaqCategoryDashboardComponent },
        {path: 'new', component: FaqCategoryEditComponent },
        {path: ':id/edit', component: FaqCategoryEditComponent },
      ] },
      {path: 'changelogs', children: [
        {path: '', component: ChangelogDashboardComponent },
        {path: 'new', component: ChangelogEditComponent },
        {path: ':id/edit', component: ChangelogEditComponent },
      ] },
    ]},
    { path: 'analytics', component: AnalyticTemplateUsageComponent },
    { path: 'styles', component: StylesComponent, children: [
      { path: '', component: StyleDashboardComponent},
      { path: 'new', component: StyleEditComponent},
      { path: ':id/edit/:dupe', component: StyleEditComponent},
      { path: ':id/edit', component: StyleEditComponent},
    ] },
    { path: 'settings', component: SettingAdminComponent},
    { path: 'websites', component: WebsitesComponent, children: [
      { path: '', redirectTo: 'agency-website/dashboard', pathMatch: 'full' },
      { path: ':type/dashboard', component: WebsiteDashboardComponent },
      { path: ':type/new', component: WebsiteEditComponent },
      { path: ':id/edit', component: WebsiteEditComponent },
      { path: ':type/logs', component: WebsiteLogsComponent }
    ]}
  ] }
];

@NgModule({
    imports: [RouterModule.forChild(adminRoutes)],
    exports: [RouterModule]
})
export class AdminRouteModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin.routing.module.ts